import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ErrorHandlerService {

  /**
   * Extrae un mensaje de error legible de un objeto de error HTTP
   * @param error - El objeto de error de la petición HTTP
   * @returns Un string con el mensaje de error
   */
  static getErrorMessage(error: any): string {
    // Si es un string, devolverlo directamente
    if (typeof error === 'string') {
      return error;
    }

    // Si tiene una propiedad message
    if (error?.message) {
      return error.message;
    }

    // Si tiene error.error.message (respuesta del servidor)
    if (error?.error?.message) {
      return error.error.message;
    }

    // Si error.error es un string
    if (error?.error && typeof error.error === 'string') {
      return error.error;
    }

    // Si tiene error.error.errors (errores de validación)
    if (error?.error?.errors) {
      const validationErrors = error.error.errors;
      if (typeof validationErrors === 'object') {
        return Object.values(validationErrors).flat().join(', ');
      }
      return validationErrors.toString();
    }

    // Si tiene error.error (objeto genérico)
    if (error?.error) {
      try {
        return JSON.stringify(error.error);
      } catch {
        return error.error.toString();
      }
    }

    // Fallback genérico
    return 'Error desconocido';
  }

  /**
   * Maneja un error y muestra un mensaje de alerta
   * @param error - El objeto de error
   * @param defaultMessage - Mensaje por defecto si no se puede extraer el error
   */
  static handleError(error: any, defaultMessage: string = 'Ha ocurrido un error'): void {
    const errorMessage = this.getErrorMessage(error);
    alert(`${defaultMessage}: ${errorMessage}`);
  }

  /**
   * Logs el error completo para debugging
   * @param error - El objeto de error
   * @param context - Contexto donde ocurrió el error
   */
  static logError(error: any, context: string = 'Unknown'): void {
    console.error(`[${context}] Error completo:`, error);
    console.error(`[${context}] Mensaje extraído:`, this.getErrorMessage(error));
  }
}
